import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { RingLoader } from 'react-spinners';
import { alert_success } from '../AppContext';

// SVG Icon Components
const FacebookIcon = () => (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
    </svg>
);
const InstagramIcon = () => (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4z" />
    </svg>
);
const TikTokIcon = () => (
    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 512 512">
        <path d="M412.19,118.66a109.27,109.27,0,0,1-9.45-5.5,132.87,132.87,0,0,1-24.27-20.62c-18.1-20.71-24.86-41.72-27.35-56.43h.1C349.14,23.9,350,16,350.13,16H267.69V334.78c0,4.28,0,8.51-.18,12.69,0,.52-.05,1-.08,1.56,0,.23-.05.47-.05.71,0,.06-.05.12-.05.18a70,70,0,0,1-35.22,55.56,68.8,68.8,0,0,1-34.11,9c-38.41,0-69.54-31.32-69.54-70s31.13-70,69.54-70a68.9,68.9,0,0,1,21.41,3.39l.1-83.94a153.14,153.14,0,0,0-118,34.52,161.79,161.79,0,0,0-35.3,43.53c-3.48,6-16.61,30.11-18.2,69.24-1,22.21,5.67,45.22,8.85,54.73v.2c2,5.6,9.75,24.71,22.38,40.82A167.53,167.53,0,0,0,115,470.66v-.2l.2.2C155.11,497.78,199.36,496,199.36,496c7.66-.31,33.32,0,62.46-13.81,32.32-15.31,50.72-38.12,50.72-38.12a158.46,158.46,0,0,0,27.64-45.93c7.46-19.61,9.95-43.13,9.95-52.53V176.49c1,.6,14.32,9.41,14.32,9.41s19.19,12.3,49.13,20.31c21.48,5.7,50.42,6.9,50.42,6.9V131.27C453.86,132.37,433.27,129.17,412.19,118.66Z" />
    </svg>
);

const socialConfig = {
    facebook: { bg: 'bg-blue-600', Icon: FacebookIcon },
    insta: { bg: 'bg-pink-500', Icon: InstagramIcon },
    tiktok: { bg: 'bg-black', Icon: TikTokIcon }
};

const BioLink = () => {
    const { slug_2 } = useParams();
    const [loading, setLoading] = useState(true);
    const [userSocial, setUserSocial] = useState({});
    const [linkData, setLinkData] = useState({ url: '', description: '' });
    const money = '100';
    const level = 'Vàng';

    useEffect(() => {
        const fetchData = async () => {
            if (!slug_2) return;
            try {
                setLoading(true);
                const payload = { query: { 'users.bio_links.username': slug_2 }, field: '' };
                const { data } = await axios.post(
                    'https://node_js.hust.media/main_1/mongo_1/api/mongo_find_query',
                    JSON.stringify(payload),
                    { headers: { 'Content-Type': 'application/json' } }
                );
                const info = data.api_results.mongo_results;
                // set social links
                if (info.social) {
                    setUserSocial(info.social);
                }
                // set main bio link
                if (info.lienket) {
                    setLinkData({
                        url: info.lienket.link,            // dùng .link thay vì .lienket
                        description: info.lienket.description
                    });
                }
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [slug_2]);

    function saochep(value) {
        alert_success('Đã sao chép');
        window.saochepnative(value);

    };

    const capitalize = s => s.charAt(0).toUpperCase() + s.slice(1);

    return (
        <div className="flex flex-col items-center px-4 py-8 min-h-screen">
            <div className="w-full max-w-md rounded-2xl shadow-lg p-6 space-y-6">

                {slug_2 && (
                    <h1 className="text-2xl font-bold text-center text-gray-800">
                        {slug_2}
                    </h1>
                )}

                <div className="flex justify-center space-x-4">
                    {Object.entries(socialConfig).map(([key, { bg, Icon }]) => {
                        const url = userSocial[key];
                        if (!url) return null;
                        return (
                            <a
                                key={key}
                                href={url}
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label={`Open ${capitalize(key)}`}
                                className="no-underline hover:no-underline"
                            >
                                <button className={`${bg} p-3 rounded-full text-white shadow hover:opacity-90 transition`}>
                                    <Icon />
                                </button>
                            </a>
                        );
                    })}
                </div>

                <div className="grid grid-cols-2 divide-x divide-gray-200">
                    <div className="text-center">
                        <p className="text-3xl font-semibold text-gray-800">{money}</p>
                        <p className="text-sm text-gray-500">Người theo dõi</p>
                    </div>
                    <div className="text-center">
                        <p className="text-3xl font-semibold text-gray-800">{level}</p>
                        <p className="text-sm text-gray-500">Cấp độ</p>
                    </div>
                </div>

                {loading ? (
                    <div className="flex justify-center">
                        <RingLoader size={60} />
                    </div>
                ) : (
                    <>
                        {linkData.url && (
                            <a
                                href={linkData.url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="block no-underline hover:no-underline"
                            >
                                <div className="p-3 rounded-xl shadow-md transform transition hover:scale-105 bg-gradient-to-r from-blue-100 to-pink-200 text-gray-800">
                                    <div className="truncate">{linkData.description}</div>
                                </div>
                            </a>
                        )}

                        <button
                            onClick={() => saochep('https://hust.media/shop/biolink/' + slug_2)}
                            className="w-full flex justify-center items-center space-x-2 py-3 bg-white border border-gray-300 rounded-xl hover:bg-gray-100 transition"
                        >
                            <span>Sao chép link bio</span>
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 12h13M12 5l7 7-7 7" />
                            </svg>
                        </button>

                        {Object.keys(userSocial).length > 0 && (
                            <div className="p-3 rounded-xl shadow-md transform transition hover:scale-105 bg-gradient-to-r from-blue-100 to-pink-200 text-gray-800 space-y-1">
                                {Object.entries(userSocial).map(([type, url]) => (
                                    <a
                                        key={type}
                                        href={url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="block truncate hover:underline text-black"
                                    >
                                        <strong className="text-black">{capitalize(type)}:</strong>{' '}
                                        <span className="text-black">{url}</span>
                                    </a>
                                ))}
                            </div>
                        )}

                    </>
                )}
            </div>
        </div>
    );
};

export default BioLink;
